import {
  UPDATE_FIELD_FROM_DID_YOU_MEAN
} from 'actions';

function getFormName() {
  let fullPath = window.location.pathname;
  while (fullPath.endsWith('/')) {
    fullPath = fullPath.slice(0, -1);
  }
  const pathLevels = fullPath.split('/');
  const formNameLevel = Math.max(0, pathLevels.length - 2);
  return `${ pathLevels[formNameLevel] }-form`;
}

/**
 * The form reducer
 */
// eslint-disable-next-line
function form(state = { ...state }, action) {
  switch (action.type) {
    case UPDATE_FIELD_FROM_DID_YOU_MEAN:
      // eslint-disable-next-line
      let formName = getFormName();
      if (formName != null) {
        formName = formName.replace('_2024', '');// short term fix whilst 2024 forms map to one type
        formName = formName.replace('_2023', '');// short term fix whilst 2023 forms map to one type
        formName = formName.replace('_2022', '');// short term fix whilst 2022 forms map to one type
        formName = formName.replace('_2021', '');// short term fix whilst 2021 forms map to one type
        formName = formName.replace('_2018', '');// short term fix whilst 2018 forms map to one type
        formName = formName.replace('_2017', '');// short term fix whilst 2017 forms map to one type
        formName = formName.replace('_2016', '');// short term fix whilst 2016 forms map to one type
        formName = formName.replace('_2014', '');// short term fix whilst 2014 forms map to one type
        formName = formName.replace('dt_', '');// short term fix whilst dt forms map to one type
      }

      if (action.stateFieldName != null) {
        const items = action.stateFieldName.split('.');
        const newForm = Object.assign({}, state[formName]);
        if (newForm != null && newForm.values !== undefined && items != null) {
          let ref = newForm.values;
          for (let i = 0; i < items.length - 1; i += 1) {
            const arrayIndexStart = items[i].indexOf('[');
            const arrayIndexEnd = items[i].indexOf(']');
            if (arrayIndexStart > -1 && arrayIndexEnd > -1) {
              const arrayIndex = items[i].substring(arrayIndexStart + 1, arrayIndexEnd);
              if (!Number.isNaN(arrayIndex)) {
                const iArrayIndex = parseInt(arrayIndex, 10);
                ref = ref[items[i].substring(0, arrayIndexStart)];
                if (ref && Array.isArray(ref) && iArrayIndex < ref.length) {
                  ref = ref[iArrayIndex];
                } else {
                  ref = ref[items[i]];
                }
              } else {
                ref = ref[items[i]];
              }
            } else {
              ref = ref[items[i]];
            }
          }
          const fieldName = items[items.length - 1];
          ref[fieldName] = action.stateFieldValue;
          const newState = {
            ...state,
            [formName]: newForm
          };
          return newState;
        }
      }
      return state;
    default:
      return state;
  }
}

export default form;
